import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { FormControl } from '@angular/forms';
import { FirebaseProvider } from './../../providers/firebase/firebase';
import { FirebaseListObservable } from 'angularfire2/database';
//import { Observable } from 'rxjs/observable';
import 'rxjs/add/operator/debounceTime';

import { NhfSchema } from './nhfSchema';
//import { NewdrugPage } from '../newdrug/newdrug';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  nhfdrugs: FirebaseListObservable<any[]>;
  itemlist: NhfSchema[]; // Observable<any>;
  newDrug;
  searchTerm: string = '';
  searchControl: FormControl;
  searching: any = false;

  constructor(public navCtrl: NavController, public firebaseProvider: FirebaseProvider) {
 
     this.searchControl = new FormControl();
     this.initialDrug();
  //   this.drugs = this.firebaseProvider.getDrugs();
     this.setFilteredItems();
  }

  ionViewDidLoad(){
  //   this.setFilteredItems();

  //   this.searchControl.valueChanges.debounceTime(700).subscribe(search => {
  //          this.searching = false;
  //          this.setFilteredItems();
  //        })
  }

  initialDrug() {
    this.itemlist = [];
   this.newDrug = {"drug": "", "info": "", "ndc": "", "status": ""}
 }

  onSearchInput(){
        this.searching = true;
    }

  getItem() {
     this.nhfdrugs = this.firebaseProvider.fetchItems();
	 this.searching = false;
  }

  addItem() {
    this.firebaseProvider.addDrug(this.newDrug);
	 this.searching = false;
  }
 
  removeItem(id) {
    this.firebaseProvider.removeDrug(id);
	 this.searching = false;
  }

  nhf() {
     this.navCtrl.push('NhfDrug');
	 this.searching = false;
  }
   
   viewDrugs() {
		this.navCtrl.push('DrugPage');
		this.searching = false;
   }

    setFilteredItems() {
      //  this.itemlist = this.firebaseProvider.filterItems(this.searchTerm);
      this.firebaseProvider.getList()
      .subscribe((data) => this.xtraList(data))
    }

    xtraList(list) {
      this.itemlist = list;
      console.log(list);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts